import { render } from "./ShowRecordPatient.vue?vue&type=template&id=049e3c46&ts=true"
import script from "./ShowRecordPatient.vue?vue&type=script&lang=ts"
export * from "./ShowRecordPatient.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/dev.poct.nikted.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__